<template>
  <span :title="title" :style="getStyle(colour)" class="micad_riskIcon"></span>
</template>

<script>
export default {
  name: 'Risk-icons',
  data() {
    return {
        title: "High",
        colour: "#ff0000" 
      }
    },
    props: {
      type: String,
  },
  methods: {
   getStyle(colour) {
    return 'background: '+colour
    }
  }
};
</script>

